export interface EditorSettings {
  formatOnSave: boolean;
  formatOnPaste: boolean;
  autocomplete: boolean;
}

export const DEFAULT_EDITOR_SETTINGS: EditorSettings = {
  formatOnSave: false,
  formatOnPaste: true,
  autocomplete: false,
};

const SETTINGS_KEY = "racler.editor.settings.v1";

const getStorage = () => (typeof localStorage !== "undefined" ? localStorage : undefined);

export function loadEditorSettings(storage?: Storage): EditorSettings {
  try {
    const s = storage ?? getStorage();
    if (!s) return { ...DEFAULT_EDITOR_SETTINGS };
    const raw = s.getItem(SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_EDITOR_SETTINGS };
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      const obj = parsed as Record<string, unknown>;
      return {
        formatOnSave: typeof obj["formatOnSave"] === "boolean" ? obj["formatOnSave"] : DEFAULT_EDITOR_SETTINGS.formatOnSave,
        formatOnPaste: typeof obj["formatOnPaste"] === "boolean" ? obj["formatOnPaste"] : DEFAULT_EDITOR_SETTINGS.formatOnPaste,
        autocomplete: typeof obj["autocomplete"] === "boolean" ? obj["autocomplete"] : DEFAULT_EDITOR_SETTINGS.autocomplete,
      };
    }
    return { ...DEFAULT_EDITOR_SETTINGS };
  } catch {
    return { ...DEFAULT_EDITOR_SETTINGS };
  }
}

export function saveEditorSettings(settings: EditorSettings, storage?: Storage): void {
  try {
    const s = storage ?? getStorage();
    if (!s) return;
    s.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    // ignore
  }
}
